const HELP_ICON = {
    EVENT: 'HelpIcon',
    EVENT_PROPERTIES: {
        DESCRIPTION: 'Section:',
    },
};

export default HELP_ICON;
